import StoreSmCardLoader from './StoreSmCardLoader';

const CategoryLoader = ({ className }: any) => {
  return (
    <>
      <div className="categories-row">
        <div>
          <StoreSmCardLoader className={className ? className : ''} />
        </div>
        <div>
          <StoreSmCardLoader />
        </div>
        <div>
          <StoreSmCardLoader />
        </div>
        <div>
          <StoreSmCardLoader />
        </div>
        <div>
          <StoreSmCardLoader />
        </div>
        <div>
          <StoreSmCardLoader />
        </div>

        <div>
          <StoreSmCardLoader />
        </div>
        <div>
          <StoreSmCardLoader />
        </div>
        <div>
          <StoreSmCardLoader />
        </div>
        <div>
          <StoreSmCardLoader />
        </div>
      </div>
    </>
  );
};

export default CategoryLoader;
